import { render, staticRenderFns } from "./VSectionTitle.vue?vue&type=template&id=6b50393a&scoped=true"
import script from "./VSectionTitle.vue?vue&type=script&lang=js"
export * from "./VSectionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b50393a",
  null
  
)

export default component.exports